import { useQuery } from '@tanstack/react-query';

import { journalTypeOptions } from '@/module/Nomen/JournalType/model/JournalTypeModel';

import { FilterInputProps, SelectFilter, useFilterOptions } from '@/core/components';

type JournalTypeFilterProps = FilterInputProps;

export function JournalTypeFilter(props: JournalTypeFilterProps) {
  const { data, isLoading, isError } = useQuery(journalTypeOptions.getAll());
  const options = useFilterOptions(data);
  return (
    <SelectFilter
      isError={isError}
      isLoading={isLoading}
      options={options}
      {...props}
    />
  );
}
